export default "__VITE_ASSET__798066cd__"